import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root'
})
export class NcdtermsheetService {

  constructor(private httpService: HttpService) { }

  updateLibraryField(termsheet, id) {
    var request = {
      URL: 'ncdLibrary/update/' + id,
      DATA: termsheet
    }
    return this.httpService.post(request);
  }

  getTermsheetData(object) {
    var termsheetList = {
      URL: "ncdLibrary/getLibraryData",
      DATA: object
    }
    return this.httpService.post(termsheetList);
  }

  getTermsheetDetailsById(id) {
    var request = {
      URL: 'ncdLibrary/getLibraryDetailsById/' + id
    }
    return this.httpService.get(request);
  }

  removeTermsheetDetails(_id) {
    var request = {
      URL: "ncdLibrary/deleteNcdLibraryField/" + _id
    }
    return this.httpService.get(request);
  }

  // =======================================Generated Termsheet===================================================

  getIssueSpecificTermSheet(issueId) {
    var request = {
      URL: 'ncdIssues/getissueSpecificTermsheet/' + issueId
    }
    return this.httpService.get(request);
  }

  updateGeneratedTermsheet(object) {
    var request = {
      URL: 'ncdIssues/updateTermsheet',
      DATA: object
    }
    return this.httpService.post(request);
  }


  updateIssueSpecificTermsheet(object) {
    var request = {
      URL: 'ncdIssues/updateIssueSpecificTermsheet',
      DATA: object
    }
    return this.httpService.post(request);
  }

  updateIssueSpecificTermsheetInLibrary(object) {
    var request = {
      URL: 'ncdIssues/updateIssueSpecificTermsheetInLibrary',
      DATA: object
    }
    return this.httpService.post(request);
  }

  termSheetApprovalByChecker(checkersDetailarray){
    var request = {
      URL: 'ncdIssues/EmailNotificationFortermSheetApprovalByChecker',
      DATA: checkersDetailarray
    }
    return this.httpService.post(request);
  }

  generateTermsheetDocument(termsheetId) {
    var request = {
      URL: 'ncdIssues/generateTermsheet/' + termsheetId,
    }
    return this.httpService.get(request);
  }

  downloadTermsheetDocument(issueId) {
    var token = localStorage.getItem('token')
    // var request = {
    //   URL: 'ncdIssues/downloadTermsheet/' + termsheetId,
    // }
    // return this.httpService.get(request);
    window.location.href = environment.pssServerUrl + "ncdIssues/downloadTermsheet/" + issueId + "/" + token;;
  }

  // CASHFLOW
  getHolidayCheckForCashflow() {
    var request = {
      URL: 'ncdTermsheet/checkHolidayForCashflowsDate'
    }
    return this.httpService.get(request);
  }
}
